import { FormatNumberWithCommas } from "../../../../../shared/scripts/number-functions";
import { TableColumnGroup, TableColumnVisibilityController } from "../../../../../shared/scripts/table-column-visibility";
import { DestroyTable, RenderDateMDY, RenderDateYMD, RenderDays } from "../../../../../shared/scripts/table-functions";
import { SiteMilestone } from "../../../sites/site-activation/scripts/site-activation.entities";
import { Contract, ContractHistory } from "../../scripts/contracts.entities";

export class ContractDetailsTab {

    tableId: string = "contracts-current-table";
    tableWrapperId: string = this.tableId + "_wrapper";
    dataTable: any;
    tableColumnController: TableColumnVisibilityController;

    modalHistoryData: ContractHistory[];
    modalHistoryTableId: string = "contract-history-table";
    modalHistoryTableWrapper: string = this.modalHistoryTableId + "_wrapper";

    modalMilestoneData: SiteMilestone[];
    modalMilestoneTableId: string = "contract-milestone-table";
    modalMilestoneTableWrapper: string = this.modalMilestoneTableId + "_wrapper";

    constructor(contracts: Contract[]) {

        this.initializeModals();

        let columns: any[] = [
            { data: "ContractType", title: "Contract Type", className: "category text-left font-size12 nowrap" },
            { data: { _: "ContractNameDisplay", sort: "ContractName" }, title: "Contract Name", className: "text-left font-size12" },
            { data: "ContractNumber", title: "Contract Number", className: "contract-number text-left font-size12 nowrap" },
            { data: "PrimeContract", title: "Prime Contract", className: "prime-contract text-left font-size12 nowrap" },
            { data: "StatusGroup", title: "Status Group", className: "status-group text-left font-size12 nowrap" },
            { data: { _: "StatusDisplay", sort: "Status" }, title: "Contract Status", className: "status link text-left font-size12 nowrap" },
            { data: "DateContractAdded", title: "Contract Added", className: "added-date text-center font-size12 nowrap", render: RenderDateMDY },
            { data: "DateLastStatusStart", title: "Last Status Change", className: "last-status-change-date text-center font-size12 nowrap", render: RenderDateMDY },
            { data: "DateContractStart", title: "Contract Started", className: "start-date text-center font-size12 nowrap", render: RenderDateMDY },
            { data: "DateContractEnd", title: "Contract Ended", className: "end-date text-center font-size12 nowrap", render: RenderDateMDY },
            { data: "DateExecuted", title: "Date Executed", className: "executed-date text-center font-size12 nowrap", render: RenderDateMDY },
            { data: "DaysToExecution", title: "Time to Execution", className: "days-to-execution text-center font-size12 nowrap", render: RenderDays },
            { data: { _: "SiteNumberDisplay", sort: "SiteNumber" }, title: "Site Id", className: "site-id text-center font-size12 nowrap" },
            { data: { _: "MilestoneDisplay", sort: "MilestoneDisplay" }, title: "Latest Site Milestone", className: "milestone link text-left font-size12 nowrap" },
        ];

        this.dataTable = $('#' + this.tableId).DataTable({
            "dom": '<"top-controls"<"column-select"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: true,
            pagingType: 'simple',
            pageLength: 50,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 2
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            order: [[0, 'asc'], [1, 'asc'], [6, 'asc']],
            data: contracts
        });

        $("#" + this.tableWrapperId + " .top-controls").addClass('row mx-0');

        $("#" + this.tableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + this.tableWrapperId + " .column-select").empty().html('<div id="' + this.tableId + '-column-select"></div>');

        $("#" + this.tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + this.tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        $("#" + this.tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + this.tableId + '-found-count\"></span></div>');
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnController = new TableColumnVisibilityController(this.tableId, (this.tableId + '-column-select'), [
            new TableColumnGroup("Contract Number", false, [], "contract-number"),
            new TableColumnGroup("Prime Contract", true, [], "prime-contract"),
            new TableColumnGroup("Status Group", false, [], "status-group"),
            new TableColumnGroup("Status", true, [], "status"),
            new TableColumnGroup("Date Added", true, [], "added-date"),
            new TableColumnGroup("Date Last Status Changed", true, [], "last-status-change-date"),
            new TableColumnGroup("Date Contract Started", false, [], "start-date"),
            new TableColumnGroup("Date Contract Ended", false, [], "end-date"),
            new TableColumnGroup("Date Executed", false, [], "executed-date"),
            new TableColumnGroup("Time to Execution", false, [], "days-to-execution"),
            new TableColumnGroup("Site Id", false, [], "site-id"), 
            new TableColumnGroup("Site Milestones", true, [], "milestones"),            
        ]);

        $('#' + this.tableId).on('search.dt', (e, settings) => {
            this.setCountFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });
        this.setCountFoundLabel(contracts.length);
    }

    setCountFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#' + this.tableId + '-found-count').text("No Contracts Found"); break;
            case 1: $('#' + this.tableId + '-found-count').text("1 Contract Found"); break;
            default: $('#' + this.tableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Contracts Found");
        }
    }

    refresh(): void {
        this.dataTable.columns.adjust();
        this.tableColumnController.refresh();
    }

    updateContent(matchingContracts: Contract[]): void {

        //console.log(matchingContracts);

        this.dataTable.clear();
        this.dataTable.rows.add(matchingContracts).draw();
        this.setCountFoundLabel(matchingContracts.length);
    }

    initializeModals(): void {
        $('#contract-history-modal').on('shown.bs.modal', () => {
            this.initializeHistoryModalTable();
            $('#' + this.modalHistoryTableId).DataTable().columns.adjust().draw();
        });

        $('#contract-history-modal').on('hidden.bs.modal', () => { DestroyTable('#' + this.modalHistoryTableId); });

        $('#contract-milestone-modal').on('shown.bs.modal', () => {
            this.initializeMilestoneModalTable();
            $('#' + this.modalMilestoneTableId).DataTable().columns.adjust().draw();
        });

        $('#contract-milestone-modal').on('hidden.bs.modal', () => { DestroyTable('#' + this.modalMilestoneTableId); });
    }

    showModal(contract: Contract, view: string): void {
        let modalId: string = "";

        if (view == "history") {
            this.modalHistoryData = contract.History;
            modalId = "contract-history-modal";
        }
        else if (view == "milestone") {
            this.modalMilestoneData = contract.Milestones;
            modalId = "contract-milestone-modal";
        }

        var modal = $('#' + modalId);
        modal.find('#modal-title').html(contract.ContractName);
        modal.modal('show');
    }

    initializeHistoryModalTable(): void {
        $('#' + this.modalHistoryTableId).DataTable({
            "dom": '<"top-controls"<"column-select">>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 2
            },
            columns: [
                { data: "ContractType", title: "Contract Type", className: "category text-left font-size12 nowrap" },
                { data: { _: "ContractNameDisplay", sort: "ContractName" }, title: "Contract Name", className: "text-left font-size12" },
                { data: "ContractNumber", title: "Contract Number", className: "contract-number text-left font-size12 nowrap" },
                { data: "PrimeContract", title: "Prime Contract", className: "prime-contract text-left font-size12 nowrap" },
                { data: "StatusGroup", title: "Status Group", className: "status-group text-left font-size12 nowrap" },
                { data: "Status", title: "Status", className: "status text-left font-size12 nowrap" },
                { data: "DateStatusStart", title: "Status Start Date", className: "start-date text-center font-size12 nowrap", render: RenderDateMDY },
                { data: "DateStatusEnd", title: "Status End Date", className: "end-date text-center font-size12 nowrap", render: RenderDateMDY },
                { data: "Duration", title: "Duration", className: "duration text-center font-size12 nowrap", render: RenderDays },
                { data: "SortDate", title: "SortOrder", visible: false },
            ],
            order: [[9, 'asc']],
            data: this.modalHistoryData
        });

        $("#" + this.modalHistoryTableWrapper + " .top-controls").addClass('row mx-0');

        $("#" + this.modalHistoryTableWrapper + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + this.modalHistoryTableWrapper + " .column-select").empty().html('<div id="' + this.modalHistoryTableId + '-column-select"></div>');

        this.tableColumnController = new TableColumnVisibilityController(this.modalHistoryTableId, (this.modalHistoryTableId + '-column-select'), [
            new TableColumnGroup("Contract Number", false, [], "contract-number"),
            new TableColumnGroup("Prime Contract", false, [], "prime-contract"),
            new TableColumnGroup("Status Group", false, [], "status-group"),
            new TableColumnGroup("Status", true, [], "status"),
            new TableColumnGroup("Start Date", true, [], "start-date"),
            new TableColumnGroup("End Date", true, [], "end-date"),
            new TableColumnGroup("Duration", true, [], "duration"),
        ]);
    }

    initializeMilestoneModalTable(): void {
        $('#' + this.modalMilestoneTableId).DataTable({
            "dom": '<"top-controls"<"column-select">>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            columns: [
                { data: { _: "SiteNameDisplay", sort: "SiteName" }, title: "Site Name", className: "text-left font-size12" },
                { data: { _: "SiteNumberDisplay", sort: "SiteNumber" }, title: "Site Id", className: "site-id text-center font-size12 nowrap" },
                { data: "PrimeContract", title: "Prime Contract", className: "prime-contract text-center font-size12 nowrap" },
                { data: "Milestone", title: "Milestone", className: "milestone text-left font-size12 nowrap" },
                { data: "DateCompletion", title: "Completion Date", className: "completion-date text-center font-size12 nowrap", render: RenderDateMDY },
                { data: { _: "CommentDisplay", sort: "Comment" }, title: "Comments", className: "comments text-left font-size12" },
                { data: "OrderBy", title: "OrderBy", visible: false },
            ],
            order: [[1, 'asc'], [6, 'asc']],
            data: this.modalMilestoneData
        });

        $("#" + this.modalMilestoneTableWrapper + " .top-controls").addClass('row mx-0');

        $("#" + this.modalMilestoneTableWrapper + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + this.modalMilestoneTableWrapper + " .column-select").empty().html('<div id="' + this.modalMilestoneTableId + '-column-select"></div>');

        this.tableColumnController = new TableColumnVisibilityController(this.modalMilestoneTableId, (this.modalMilestoneTableId + '-column-select'), [
            new TableColumnGroup("Site Id", true, [], "site-id"),
            new TableColumnGroup("Prime Contract", true, [], "prime-contract"),
            new TableColumnGroup("Milestone", true, [], "milestone"),
            new TableColumnGroup("Completion Date", true, [], "completion-date"),
            new TableColumnGroup("Comments", true, [], "comments"),
        ]);
    }

    clearSearchBar(): void {
        this.dataTable.search('').draw();
    }
}